import { useMemo } from 'react';

import { useCurrentUser } from 'shared-hooks/user';
import { useCurrentTeam } from 'shared-hooks/team';
import { useCanUser } from 'shared-hooks/permission';

const UserChatButton = ({ id, role, pending, children }) => {
    const currentTeam = useCurrentTeam();
    const currentUser = useCurrentUser();
    const haveFullChat = useCanUser('fullChat');
    const haveGuestChat = useCanUser('guestChat');
    const haveOwnerChat = useCanUser('ownerChat');

    const chatDisabled = useMemo(() => currentTeam?.chat_disabled, [currentTeam]);
    const guestChatDisabled = useMemo(() => currentTeam?.client_chat_disabled, [currentTeam]);

    if (chatDisabled) {
        return null;
    }

    if (currentUser?.role === 'client' && (!haveGuestChat || guestChatDisabled)) {
        return null
    }

    if (role === 'client' && (!haveGuestChat || guestChatDisabled)) {
        return null;
    }

    if (role === 'owner' && (!haveOwnerChat || guestChatDisabled)) {
        return null;
    }

    if (id === currentUser?.id || pending) {
        return null;
    }

    if (!haveFullChat && !haveGuestChat && !haveOwnerChat) {
        return null;
    }

    return children;
}

export default UserChatButton;
